import { render, staticRenderFns } from "./registry.component.html?vue&type=template&id=06464e1f&scoped=true&"
import script from "./registry.component.ts?vue&type=script&lang=ts&"
export * from "./registry.component.ts?vue&type=script&lang=ts&"
import style0 from "./registry.component.scss?vue&type=style&index=0&id=06464e1f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06464e1f",
  null
  
)

export default component.exports